import { filter, isEmpty, map, split } from 'lodash'

import {
  EXTRA_INGREDIENT_TYPES,
  INGREDIENT_PHRASE_TYPES,
} from '../../constants'

const transformToUpdateIngredientExtraDetailsArgs = data => ({
  phrases: [
    ...map(
      filter(split(data.pairingPhrases, '\n'), phrase => !isEmpty(phrase)),
      phrase => ({
        phrase,
        type: INGREDIENT_PHRASE_TYPES.PAIRING,
      }),
    ),
    ...map(
      filter(split(data.referencingPhrases, '\n'), phrase => !isEmpty(phrase)),
      phrase => ({
        phrase,
        type: INGREDIENT_PHRASE_TYPES.REFERENCING,
      }),
    ),
    ...map(
      filter(
        split(data.negativeSynonymPhrases, '\n'),
        phrase => !isEmpty(phrase),
      ),
      phrase => ({
        phrase,
        type: INGREDIENT_PHRASE_TYPES.NEGATIVE_SYNONYM,
      }),
    ),
  ],
  extraIngredients: [
    ...map(data.pairingIngredientIds, ({ value: id }) => ({
      id,
      type: EXTRA_INGREDIENT_TYPES.PAIRING,
    })),
    ...map(data.referenceIngredientIds, ({ value: id }) => ({
      id,
      type: EXTRA_INGREDIENT_TYPES.REFERENCE,
    })),
  ],
})

export default transformToUpdateIngredientExtraDetailsArgs
